<template>
  <img
    class="excel-icon"
    src="../assets/img/excel_dwn_lrg.png"
    alt="Excel Icon"
    style="padding-top: 4px"
  />
</template>
